import { Semaphore } from "@thewass/wass-lib";
import { callRecalcPost } from "$lib/providers/http";
import type { BatchDataRequest, BatchDataResponse } from "@sa/services/interfaces/batchRecalc";

export async function sendBatchData(batchData: Array<BatchDataRequest>): Promise<Array<BatchDataResponse>> {
    const sem = Semaphore.get('batch_data_custom_function', 6);
    await sem.acquire();
    try {
        const data = { batchData };
        const res: Array<BatchDataResponse> = await callRecalcPost('function', 'batch_process', data);
        return res;
    } finally {
        sem.release();
    }
}